<template>
  <div
    class="header-container w-full shrink-0 px-3 sm:px-5 py-3 bg-box-container-bg dark:bg-box-container-bg-dark border-b border-container-border dark:border-container-border-dark flex items-center justify-between gap-3"
  >
    <div class="flex items-center min-w-0">
      <slot name="toggle-sidebar"></slot>
      <div
        v-if="$slots['toggle-sidebar']"
        class="w-px h-6 bg-container-border dark:bg-container-border-dark ml-2 lg:hidden"
      ></div>
      <router-link to="/" class="flex items-center ml-2 lg:ml-0">
        <slot name="logo"></slot>
      </router-link>
    </div>

    <div v-if="$slots['right-element']" class="flex items-center shrink-0">
      <slot name="right-element"></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
